import { UITextSmNormal } from '@gohighlevel/ghl-ui';
import dayjs from 'dayjs';
import { h } from 'vue';
export const renderDateTime = (date) => {
    if (!date) {
        return h(UITextSmNormal, {}, { default: () => '-' });
    }
    const format = dayjs(date).add(365, 'days').isBefore(dayjs())
        ? 'MMM D, YYYY'
        : 'MMM D [at] hh:mm A';
    return h('div', [
        h(UITextSmNormal, {}, { default: () => dayjs(date).format(format) }),
    ]);
};
